import { render } from "./Bitacora.vue?vue&type=template&id=5860edc9"
import script from "./Bitacora.vue?vue&type=script&lang=js"
export * from "./Bitacora.vue?vue&type=script&lang=js"

import "./Bitacora.vue?vue&type=style&index=0&id=5860edc9&lang=css"

import exportComponent from "/Users/alexnovoa/Documents/PersonalDrive/proyectos-vue/cn-chatbot-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__